import { render } from "./OnDemandBookingWaitingRoom.vue?vue&type=template&id=55a54dde&scoped=true&ts=true"
import script from "./OnDemandBookingWaitingRoom.vue?vue&type=script&lang=ts"
export * from "./OnDemandBookingWaitingRoom.vue?vue&type=script&lang=ts"

import "./OnDemandBookingWaitingRoom.vue?vue&type=style&index=0&id=55a54dde&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a54dde"]])

export default __exports__